export const SeasonStatus=Object.freeze({
    ACTIVE:"ACTIVE",
    REGISTRATION_OPENED:"REGISTRATION_OPENED",
    REGISTRATION_CLOSED:"REGISTRATION_CLOSED",
    DISABLED:"DISABLED"
})